import { Skeleton } from '@/components/ui/Skeleton.tsx'
import { cn } from '@/lib/utils.ts'

const NavSkeleton = () => {
  const skeletonHeight = 'h-[24px]'
  return (
    <div className="hidden h-[80svh] w-full md:grid md:grid-cols-[var(--sidebar-width)_1fr]">
      <div className="flex-col border-r bg-prologisAccent md:flex">
        <div className="flex max-h-svh flex-col gap-2 p-4">
          <Skeleton className={cn(`h-[24px] w-1/2`)} />
        </div>
        <hr className={`my-4`} />
        <div className="flex max-h-svh flex-col gap-2 p-4">
          <Skeleton className={cn(`w-3/4`, skeletonHeight)} />
          <Skeleton className={cn(`w-full`, skeletonHeight)} />
          <Skeleton className={cn(`w-1/2`, skeletonHeight)} />
          <Skeleton className={cn(`w-full`, skeletonHeight)} />
        </div>
        <hr className={`my-4`} />
        <div className="flex max-h-svh flex-col gap-2 p-4">
          <Skeleton className={cn(`w-full`, skeletonHeight)} />
          <Skeleton className={cn(`w-1/2`, skeletonHeight)} />
          <Skeleton className={cn(`w-full`, skeletonHeight)} />
          <Skeleton className={cn(`w-3/4`, skeletonHeight)} />
        </div>
        <hr className={`my-4`} />
        <div className="flex max-h-svh flex-col gap-2 p-4">
          <Skeleton className={cn(`w-3/4`, skeletonHeight)} />
          <Skeleton className={cn(`w-full`, skeletonHeight)} />
          <Skeleton className={cn(`w-1/2`, skeletonHeight)} />
          <Skeleton className={cn(`w-full`, skeletonHeight)} />
        </div>
      </div>
    </div>
  )
}

export default NavSkeleton
